import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import RcPagination from 'rc-pagination'

class Pagination extends PureComponent {
  render () {
    return (
      <RcPagination style={this.props.style} className="pagination" current={this.props.current}
                    total={this.props.total} showTitle={false}
                    pageSize={this.props.pageSize} onChange={this.props.onChange}/>
    )
  }

  static calculatePage (offset, limit) {
    return Math.ceil((offset) / (limit)) + 1
  }

  static calculateOffset (page, limit) {
    return (page - 1) * (limit)
  }
}

Pagination.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Pagination
